module.exports = __webpack_public_path__ + "img/flow.a2dcec0c.jpg";